import React, { useContext } from "react";
import { Button, Drawer } from "@mui/material";
import ProfileMenu from "../../components/profile/ProfileMenu";
import { useAppState } from "../../states/app-state";
import { Observer } from "mobx-react-lite";
import LoginPopup from "../login/LoginPopup";
import MenuDrawer from "../../containers/menudrawer/MenuDrawer";
import styles from './BearerMenu.module.scss'; // added by Bearer Web Developer
import { MenuDrawerContext, toggleMenuDrawer } from "../../states/contexts/menuDrawer"; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer
export default function BearerMenu() {

    const appState = useAppState();
    // move login state to loginState of mobx states by Bearer Web Developer
    const handleOpenLoginPopup = () => {
        appState.login.setOpen(true); // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
    }
    // const handleCloseLoginPopup = () => { // commented by Bearer Web Developer (not needed)
    //     appState.login.setOpen(false);
    // }
    const menuDrawer = useContext(MenuDrawerContext); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <>
            <Observer>{() => (
                <>
                    <div style={{ display: "none" }} id="recaptcha-sign-in-container"></div>  {/* added by Bearer Web Developer (RecaptchaVerifier for sign in with phone number for individual) */}
                    <LoginPopup open={appState.login?.open} />
                    <div className={styles.root}>

                        <div className={styles.actions}>
                            <MenuDrawer />
                        </div>
                        <div className={styles.actions}>
                            {appState.login.loggedin ? <ProfileMenu /> :
                                <Button className={styles.login} onClick={handleOpenLoginPopup}
                                    disableRipple={true}>Log in</Button>
                            }
                        </div>
                        {/* added for mobile screen by Bearer Web Developer start */}
                        {
                            appState.login.loggedin &&
                            <Drawer
                                anchor={'left'}
                                open={menuDrawer.openDrawer}
                                onClose={toggleMenuDrawer(false, menuDrawer.setOpenDrawer)}
                                PaperProps={{
                                    style: { background: "none", boxShadow: "none", width: "100%", maxWidth: "290px" }
                                }}
                                className={styles.main_drawer_menu}
                            >
                                <div className={styles.drawer_menu}>
                                    <div className={styles.drawer_menu_items}>
                                        <div className={styles.actions}>
                                            <MenuDrawer />
                                        </div>
                                        <div className={styles.actions}>
                                            <ProfileMenu />
                                        </div>
                                    </div>
                                </div>
                            </Drawer>
                        }
                        {/* added for mobile screen by Bearer Web Developer end */}

                    </div>
                </>
            )}</Observer>
        </>
    );
    // modified by Bearer Web Developer end
}
